export default "__VITE_ASSET__35327608__"